import { Injectable } from '@angular/core';
import { HttpClient } from './http-client.service';
import { Seatingplan } from '../../models/seatingplan.model';
import { Logger } from '../logger.service';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';

@Injectable()
export class SeatingplanApi {
	private seatingplanUrl = '/api/seatingplans/v1/seatingplans';
	constructor(private httpClient: HttpClient, private logger: Logger) {}

	public createSeatingplan(seatingplan: Seatingplan): Observable<Seatingplan> {
		let body = JSON.stringify(seatingplan);
		this.logger.info("Save Seatingplan: " + seatingplan.name);
		return this.httpClient.post(this.seatingplanUrl, body)
			.map(response => <Seatingplan>response.json())
			.catch(this.handleError)
	}

	public updateSeatingplan(url: string, seatingplan: Seatingplan): Observable<Seatingplan> {
		let body = JSON.stringify(seatingplan);
		return this.httpClient.patch(url, body)
			.map(response => <Seatingplan>response.json())
			.catch(this.handleError)
	}

	public loadSeatingplanById(id: string): Observable<Seatingplan> {
		this.logger.info("Get Seatingplan by Id:" + id);
		return this.httpClient.get(this.seatingplanUrl + "/" + id + "?projection=noJson")
			.map(response => <Seatingplan>response.json())
			.catch(this.handleError);
	}

	public loadSeatingplanByUuid(uuid: string): Observable<Seatingplan> {
		this.logger.info("Get Seatingplan by Uuid:" + uuid);
		return this.httpClient.get(this.seatingplanUrl + "/search/findByUuid?uuid=" + uuid)
			.map(response => <Seatingplan>response.json())
			.catch(this.handleError);
	}

	public loadSeatingplans(): Observable<Seatingplan[]> {
		return this.httpClient.get(this.seatingplanUrl+"?projection=noJson&size=100")
			.map(response => <Seatingplan[]>response.json()._embedded.seatingplans)
			.catch(this.handleError)
	}

	public deleteSeatingplan(id: string): Observable<Response> {
		return this.httpClient.delete(this.seatingplanUrl + '/' + id)
			.catch(this.handleError)
	}

	public copySeatingplan(id: string, newName: string): Observable<Seatingplan> {
		this.logger.info("Copy Seatingplan with Id " + id);
		return this.httpClient.post(this.seatingplanUrl + '/'+ id + '/copy?newName=' + newName)
			.map(response => <Seatingplan>response.json())
			.catch(this.handleError)
	}

	private handleError = (error: Response) => {
		this.logger.error(error);
		return Observable.throw(error);
	}

}



// WEBPACK FOOTER //
// ./src/app/services/webservice/seatingplan-api.service.ts